import cookieExt from 'js-cookie'
import { getQueryofKey, getQueryString } from '../../utils/getUrlParams'

// 获取当前链接上的所有参数
const urlParams: any = getQueryString()
const lastfrom: string = urlParams['lastfrom']

const curHost: string = window.location.host
const hostArr: any = curHost.split('.')
let oriHost: any = curHost
if (hostArr.length > 2) {
  oriHost = `${hostArr[hostArr.length - 2]}.${hostArr[hostArr.length - 1]}`
}

export function setParamsInCookies(clickId: string) {
  const timesp: any = new Date().getTime()
  const timeExp: number = 1
  if (lastfrom) {
    cookieExt.set('qd_lastfrom', lastfrom, {
      domain: oriHost,
      expires: timeExp,
      path: '/',
    })
    cookieExt.set('qd_clickid', clickId, {
      domain: oriHost,
      expires: timeExp,
      path: '/',
    })
    cookieExt.set('qd_ctime', timesp, {
      domain: oriHost,
      expires: timeExp,
      path: '/',
    })
  }
}
